import React from 'react';
import {
  Row,
  Col,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import Select from 'react-select';
import { RespondNotesEditor } from '../../../../shared/offer-domain/ui';

const SELECT_MENU_STYLE = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const findOption = (options, value) =>
  options.find(item => String(item.value) === String(value || '')) || null;

const ModalActions = ({ onCancel, onSave, saveLabel = 'Save' }) => (
  <div className='d-flex justify-content-end gap-2 mt-3'>
    <Button
      color='light'
      className='border bg-white text-dark fw-semibold px-4'
      onClick={onCancel}
    >
      Cancel
    </Button>
    <Button color='primary' className='fw-semibold px-4' onClick={onSave}>
      {saveLabel}
    </Button>
  </div>
);

export const CounterPaymentTermsModal = ({
  isOpen,
  toggle,
  draft,
  onDraftChange,
  invoiceQuantityOptions = [],
  modeOptions = [],
  currencyOptions = [],
  onSave,
  isUpdate = false,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    centered
    size='lg'
    backdrop='static'
    scrollable
  >
    <ModalHeader toggle={toggle}>Counter Payment Terms</ModalHeader>
    <ModalBody>
      <Row>
        <Col sm={4}>
          <div className='mb-3'>
            <Label className='form-label'>Invoicing Quantity</Label>
            <Select
              options={invoiceQuantityOptions}
              placeholder='Please Select'
              value={findOption(
                invoiceQuantityOptions,
                draft.invoicingQuantityId
              )}
              onChange={option =>
                onDraftChange('invoicingQuantityId', option?.value || '')
              }
              menuPortalTarget={document.body}
              styles={SELECT_MENU_STYLE}
            />
          </div>
        </Col>
        <Col sm={4}>
          <div className='mb-3'>
            <Label className='form-label'>Mode</Label>
            <Select
              options={modeOptions}
              placeholder='Please Select'
              value={findOption(modeOptions, draft.modeInvoicingQuantityId)}
              onChange={option =>
                onDraftChange('modeInvoicingQuantityId', option?.value || '')
              }
              menuPortalTarget={document.body}
              styles={SELECT_MENU_STYLE}
            />
          </div>
        </Col>
        <Col sm={4}>
          <div className='mb-3'>
            <Label className='form-label'>Currency</Label>
            <Select
              options={currencyOptions}
              placeholder='Please Select'
              value={findOption(currencyOptions, draft.paymentCurrencyId)}
              onChange={option =>
                onDraftChange('paymentCurrencyId', option?.value || '')
              }
              menuPortalTarget={document.body}
              styles={SELECT_MENU_STYLE}
            />
          </div>
        </Col>
        <Col sm={12}>
          <div className='mb-3'>
            <Label className='form-label'>Description of Payment Term</Label>
            <RespondNotesEditor
              id='counterDescriptionOfPaymentTerms'
              value={draft.descriptionOfPaymentTerms || ''}
              onChange={e =>
                onDraftChange('descriptionOfPaymentTerms', e.target.value)
              }
            />
          </div>
        </Col>
      </Row>
      <ModalActions
        onCancel={toggle}
        onSave={onSave}
        saveLabel={isUpdate ? 'Update' : 'Save'}
      />
    </ModalBody>
  </Modal>
);

export const CounterComplianceModal = ({
  isOpen,
  toggle,
  draft,
  onDraftChange,
  lawOptions = [],
  arbitrationOptions = [],
  onSave,
  isUpdate = false,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    centered
    size='lg'
    backdrop='static'
    scrollable
  >
    <ModalHeader toggle={toggle}>Counter Compliance</ModalHeader>
    <ModalBody>
      <Row>
        <Col sm={6}>
          <div className='mb-3'>
            <Label className='form-label'>Law</Label>
            <Select
              options={lawOptions}
              placeholder='Please Select'
              value={findOption(lawOptions, draft.lawId)}
              onChange={option => onDraftChange('lawId', option?.value || '')}
              menuPortalTarget={document.body}
              styles={SELECT_MENU_STYLE}
            />
          </div>
        </Col>
        <Col sm={6}>
          <div className='mb-3'>
            <Label className='form-label'>Abitration</Label>
            <Select
              options={arbitrationOptions}
              placeholder='Please Select'
              value={findOption(arbitrationOptions, draft.arbitrationId)}
              onChange={option =>
                onDraftChange('arbitrationId', option?.value || '')
              }
              menuPortalTarget={document.body}
              styles={SELECT_MENU_STYLE}
            />
          </div>
        </Col>
        <Col sm={12}>
          <div className='mb-3'>
            <Label className='form-label'>Other Terms & Condition</Label>
            <RespondNotesEditor
              id='counterOtherTermsAndCondition'
              value={draft.otherTermsAndCondition || ''}
              onChange={e =>
                onDraftChange('otherTermsAndCondition', e.target.value)
              }
            />
          </div>
        </Col>
        <Col sm={12}>
          <div className='mb-3'>
            <Label className='form-label'>Additional Notes</Label>
            <RespondNotesEditor
              id='counterAdditionalNotes'
              value={draft.additionalNotes || ''}
              onChange={e => onDraftChange('additionalNotes', e.target.value)}
            />
          </div>
        </Col>
      </Row>
      <ModalActions
        onCancel={toggle}
        onSave={onSave}
        saveLabel={isUpdate ? 'Update' : 'Save'}
      />
    </ModalBody>
  </Modal>
);
